import { render } from "./multiple-radios.vue?vue&type=template&id=3bd39e6c"
import script from "./multiple-radios.vue?vue&type=script&lang=js"
export * from "./multiple-radios.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"vendor/wielink-application/shared/resources/vue/components/form/input-only/multiple-radios.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3bd39e6c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3bd39e6c', __exports__)) {
    console.log('reload')
    api.reload('3bd39e6c', __exports__)
  }
  
  module.hot.accept("./multiple-radios.vue?vue&type=template&id=3bd39e6c", () => {
    console.log('re-render')
    api.rerender('3bd39e6c', render)
  })

}


export default __exports__